import React, { useState, useCallback } from "react";
import moment from "moment";
import toast from "react-hot-toast";
import Icon from "./Icon";
import LiveRate from "./LiveRate";
import ProfitLoss from "./ProfitLoss";
import TimeTick from "./Time";
import Backend from "../../../../Backend/Backend";

const backend = await new Backend().init();

export default function StandingCard({
  item,
  userType,
  reload,
  total,
  standing_delete,
}) {
  const [loading, setLoading] = useState(false);
  const [sqOffVisible, setSqOffVisible] = useState(false);

  const [tpassword, setTpassword] = useState("");

  // 🔹 Derived display values
  const exchangeName = (() => {
    switch (item.type) {
      case "nse":
        return "NSE";
      case "mcx":
        return "MCX";
      case "fo":
        return "OPTIONS";
      case "nse_cash":
        return "NSE-EQUITY";
      case "comex_future":
        return "COMEX";
      case "crypto_future":
        return "CRYPTO";
      case "forex_future":
        return "FOREX";
      default:
        return "NSE";
    }
  })();

  const expiryLabel =
    item.type === "nse_cash"
      ? "EQUITY"
      : moment(item.expiry_date).format("DD-MMM");

  // 🔹 Utility: safe rate formatting
  const formatRate = (rate) =>
    rate && !isNaN(rate)
      ? item.type === "forex_future"
        ? rate
        : parseFloat(rate)
      : 0;

  // 🔹 Event handlers
  const handleSqOff = useCallback(async () => {
    try {
      setLoading(true);
      const data = {
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        username: localStorage.getItem("username"),
        token: localStorage.getItem("token"),
        all: 0,
        user_id: item.user_id,
        standing_id: item.id,
        tpassword: tpassword,
      };

      let res;
      if (userType === 1) res = await backend.sq_all_admin(data);
      else if (userType === 2) res = await backend.sq_all_super(data);
      else if (userType === 3) res = await backend.sq_all_master(data);
      else if (userType === 5) res = await backend.sq_all_broker(data);
      else if (userType === 6) res = await backend.sq_all_subbroker(data);

      setLoading(false);
      setSqOffVisible(false);

      if (res.error === "False") {
        toast.success(res.message);
        reload?.();
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      setLoading(false);
      toast.error("Error while squaring off.");
      console.error(err);
    }
  }, [item, reload]);

  return (
    <li key={item.id} className={`menuContainer small addHight text`}>
      <div className="menuIcon small">
        <Icon symbol_id={item.symbol_id} item={item} />
      </div>
      <div className="menuExchange small">{exchangeName}</div>
      <div className={`menuSymbol small`}>{item.username}</div>
      <div className={`menuSymbol small `}>
        {item.symbol}
      </div>
      <div className="menuExpiry small">{expiryLabel}</div>
      <div className="menuBuyPrice small">
        <div
          className={`menuBuyPrice small ${
            item.buy_sell === 0 ? "buytext" : "selltext"
          }`}
        >
          {item.buy_sell === 0 ? "BUY" : "SELL"}
        </div>
      </div>
      <div className="menuBuyPrice small">{item.qty}</div>
      <div className="menuBuyPrice small">{formatRate(item.rate)}</div>
      <div className="menuBuyPrice small">
        <LiveRate symbol_id={item.symbol_id} buy_sell={item.buy_sell} />
      </div>
      <ProfitLoss
        symbol_id={item.symbol_id}
        item={item}
        total={total}
        userType={userType}
      />
      <div className="menuLtt small">
        <TimeTick symbol_id={item.symbol_id} />
      </div>
      <div className="menuLtt flex small flex-col items-center justify-center">
        <div className="extraSmall">
          {moment(item.date_created).format("DD-MM-YYYY")}
        </div>
        <div className="small">
          {moment(item.date_created).format("HH:mm:ss")}
        </div>
      </div>
      <div className="menuLtt flex small flex-col items-center justify-center">
        <div className="extraSmall">
          {moment(item.date_update).format("DD-MM-YYYY")}
        </div>
        <div className="small">
          {moment(item.date_update).format("HH:mm:ss")}
        </div>
      </div>

      {/* SQ-OFF Button */}
      <div onClick={() => setSqOffVisible(true)} className="menuBuyPrice small">
        <button className="dropbtnNavSub sell white">SQ-OFF</button>
      </div>

      {/* 🔹 SqOff Modal */}
      {sqOffVisible && (
        <div
          className="customModalOverlay"
          onClick={() => setSqOffVisible(false)}
        >
          <div className="customModal" onClick={(e) => e.stopPropagation()}>
            <h3 className="customModalTitle">⚠️ Sq.Off Standing</h3>
            <p className="customModalWarning">
              This action will sq.off <b>{item.username}</b> standing{" "}
              <b>{item.symbol}</b>.
            </p>

            <input
              type="password"
              placeholder="Enter Transaction password"
              value={tpassword}
              onChange={(e) => setTpassword(e.target.value)}
              disabled={loading}
              className="customInput"
            />

            <div className="customModalButtons">
              <button
                className="dropbtnNavSub white sell"
                onClick={() => setSqOffVisible(false)}
                disabled={loading}
              >
                Cancel
              </button>
              <button
                className="dropbtnNavSub white primary"
                onClick={handleSqOff}
                disabled={loading}
              >
                {loading ? "SQ.OFF..." : "Confirm Sq.Off"}
              </button>
            </div>
          </div>
        </div>
      )}
    </li>
  );
}
